function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Button, Input } from 'antd';
import styles from "./index.module.css";
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Search(props) {
  var onSearch = props.onSearch,
    onReset = props.onReset;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.searchContainer,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.searchLabel,
      children: "\u5546\u54C1\u7F16\u7801/\u540D\u79F0\uFF1A"
    }), /*#__PURE__*/_jsx(Input, {
      className: styles.searchInput,
      placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u7801/\u540D\u79F0",
      value: searchText,
      onChange: function onChange(e) {
        return setSearchText(e.target.value);
      },
      onKeyDown: function onKeyDown(e) {
        if ((e === null || e === void 0 ? void 0 : e.keyCode) === 13) {
          onSearch(searchText);
        }
      }
    }), /*#__PURE__*/_jsx(Button, {
      className: styles.searchBtn,
      onClick: function onClick() {
        setSearchText('');
        requestAnimationFrame(function () {
          onReset();
        });
      },
      children: "\u91CD\u7F6E"
    }), /*#__PURE__*/_jsx(Button, {
      className: styles.searchBtn,
      onClick: function onClick() {
        return onSearch(searchText);
      },
      type: "primary",
      children: "\u67E5\u8BE2"
    })]
  });
}
export default Search;